// Shared by the blog page (src/page/Blog.tsx) and the SEO generator, which
// renders the posts into the static blog.html and its structured data.
// Newest entry first.

export type ChangelogChange = {
  description: string;
  relatedPage?: { href: string; label: string };
};

export type ChangelogEntry = {
  // ISO date (YYYY-MM-DD), used for <time>, structured data and the sitemap
  date: string;
  title: string;
  changes: ChangelogChange[];
};

export const changelogEntries: ChangelogEntry[] = [
  {
    date: "2026-10-18",
    title: "New game items, marketplace tax and faster market data",
    changes: [
      {
        description:
          "Added the items from the latest Milky Way Idle update (Labyrinth gear, seals, capes, crates and more).",
        //relatedPage: { href: "/transmute", label: "Transmute profits" },
      },
      {
        description:
          "Profits now include the 4% marketplace tax. You can change the tax on each page.",
        //relatedPage: { href: "/decompose", label: "Decompose profits" },
      },
      {
        description:
          "Market data now refreshes automatically every 2 hours. The manual update can be used once every 5 minutes.",
        //relatedPage: { href: "/", label: "Market data age" },
      },
    ],
  },
];

export function formatChangelogDate(isoDate: string): string {
  return new Date(`${isoDate}T00:00:00Z`).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: "UTC",
  });
}

export function getLatestChangelogDate(): string | undefined {
  return changelogEntries[0]?.date;
}
